<template>
    <div class="course__edit_certificate">
        <template v-if="requestPending">
            <component-loading></component-loading>
        </template>
        <template v-else>
            <component-wrapper
                :class="'course__edit_certificate_catalogitem_wrapper course__edit_certificate_catalogitem_wrapper--custom'"
            >
                <div class="columns is-variable">
                    <div class="column">
                        <form-radio
                            :class="'course__edit_certificate_catalogitem_radio course__edit_certificate_catalogitem_radio--custom'"
                            :label="''"
                            :name="'lms-superadmin-workspace-edit-certificates-radio-custom'"
                            :items="[
                                    {
                                        name: 'Use workspace default',
                                        value: 'default'
                                    }
                                ]"
                            :value="catalogItemCertificateType"
                            @input="setCatalogItemCertificateType"
                        >Certificate: {{ defaultCertificate ? defaultCertificate.name : 'Me Learning Certificate of Completion' }}
                        </form-radio>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            :theme="'default'"
                            :name="'course-edit-certificate-catalogitem-preview'"
                            @click="performPreviewCatalogItemCertificate( defaultCertificate ? { name: defaultCertificate.name, contentId: defaultCertificate.id } : { name: 'Default' })"
                        >Preview
                        </component-button>
                    </div>
                </div>
            </component-wrapper>
            <form-radio
                :class="'course__edit_certificate_catalogitem_radio course__edit_certificate_catalogitem_radio--selected'"
                :label="''"
                :name="'course-edit-certificate-catalogitem-radio-selected'"
                :items="[
                        {
                            name: 'Select template',
                            value: 'selected'
                        }
                    ]"
                :value="catalogItemCertificateType"
                @input="setCatalogItemCertificateType"
            />
            <template v-if="catalogItemCertificateType === 'selected'">
                <component-wrapper
                    :class="'course__edit_certificate_catalogitem_wrapper course__edit_certificate_catalogitem_wrapper--selected'"
                >
                    <div class="columns is-vbottom">
                        <div class="column">
                            <form-select
                                ref="selectcertificates"
                                :disabled="!loggedInWorkspaceId"
                                :class="'course__edit_certificate_catalogitem_certificate'"
                                :data-vv-as="'certificate'"
                                :get-items-getter="'getEbsCertificatesDataMappedIdNameStatus'"
                                :get-items-getter-mapped="'getEbsCertificatesDataMappedLabelValue'"
                                :get-items-dispatch="'ebsCertificatesGet'"
                                :get-items-dispatch-data="{ workspaceId: loggedInWorkspaceId }"
                                :item-name="['certificate', 'certificates']"
                                :label="''"
                                :name="'course-edit-certificate-catalogitem-certificate'"
                                :table-labels="[
                                    {
                                        key: 'name',
                                        title: 'Name',
                                        type: 'string'
                                    }
                                ]"
                                :value="catalogItemCertificateId"
                                @input="setCatalogItemCertificateId"
                                @input-table="setCatalogItemCertificateId"
                            ></form-select>
                        </div>
                        <div class="column is-narrow">
                            <component-button
                                :disabled="getCertificateRequestPending"
                                :theme="'default'"
                                :name="'course-edit-certificate-catalogitem-preview'"
                                @click="performPreviewCatalogItemCertificate"
                            >Preview
                            </component-button>
                        </div>
                    </div>
                </component-wrapper>
            </template>
            <form-radio
                :class="'course__edit_certificate_catalogitem_radio course__edit_certificate_catalogitem_radio--disable'"
                :label="''"
                :name="'course-edit-certificate-catalogitem-radio-selected'"
                :items="[
                    {
                        name: 'Disable',
                        value: true
                    }
                ]"
                v-model="catalogItemCertificateDisabled"
            >Learners will not get certificate of course completion if this option is enabled.
            </form-radio>
        </template>
    </div>
</template>

<script>

import { validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentWrapper from '@/components/default/shared/ComponentWrapper'
import FormRadio from '@/components/default/forms/FormRadio'
import FormSelect from '@/components/default/forms/FormSelect'
import ComponentLoading from '@/components/default/shared/ComponentLoading'

export default {
  name: 'course-edit-certificate',
  components: { ComponentLoading, FormSelect, FormRadio, ComponentWrapper, ComponentButton },
  mixins: [validateBeforeRouteLeave, watchContentChangeEmit],
  data () {
    return {
      requestPending: false,
      getCertificateRequestPending: false
    }
  },
  computed: {
    catalogItemCertificateId () {
      return this.$store.getters.getEbsCatalogItemCertificateId
    },
    catalogItemCertificateType () {
      return this.$store.getters.getEbsCatalogItemCertificateType
    },
    courseId: {
      get () {
        return this.$store.getters.getEbsCourseId
      }
    },
    courseName () {
      return this.$store.getters.getEbsCourseName
    },
    catalogItemCertificateDisabled: {
      get () {
        return this.$store.getters.getEbsCatalogItemCertificateDisabled
      },
      set (value) {
        this.$store.dispatch('ebsCatalogItemSetCertificateDisabled', Boolean(value))
      }
    },
    rootItemName () {
      return 'course'
    },
    //
    isAddMode () {
      return this.$route.name.includes('-add')
    },
    isEditMode () {
      return this.$route.name.includes('-edit')
    },
    isShowMode () {
      return this.$route.name.includes('-show')
    },
    tagsContent () {
      return this.$store.getters.getTagsContentMapped
    },
    isRouteCourse () {
      return this.$route.name.includes('ebs-course-edit') || this.$route.name.includes('ebs-course-add')
    },
    isRouteCatalogItem () {
      return this.$route.name.includes('ebs-catalog-item-edit')
    },
    loggedInWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    courseWorkspaceSettingsWorkspaces () {
      return this.$store.getters.getEbsCatalogItemWorkspacesSettings
    },
    defaultCertificate () {
      return this.$store.getters.getEbsCertificatesDefault
    }
  },
  methods: {
    performPreviewCatalogItemCertificate (data) {
      const name = data && data.name ? data.name : this.courseName
      const contentId = data && data.contentId ? data.contentId : this.catalogItemCertificateId
      this.$store.dispatch('ebsCertificatePreviewByContentId', { name, contentId })
    },
    performPreviewCourseCertificate () {
      this.$store.dispatch('ebsCertificatePreviewByCourseId', this.courseId)
    },
    certificateLogoUploadImage (data) {
      this.$store.dispatch('ebsCertificateSetDefaultsLogoId', data)
    },
    getCertificate (value) {
      this.getCertificateRequestPending = true
      this.$store.dispatch('ebsCertificateGet', { certificateId: value, workspaceId: this.loggedInWorkspaceId }).finally(() => {
        this.getCertificateRequestPending = false
      })
    },
    setCatalogItemCertificateId (value) {
      this.getCertificate(value.value)
      this.$store.dispatch('ebsCatalogItemSetCertificateId', value.value)
    },
    setCatalogItemCertificateType (value) {
      this.$store.dispatch('ebsCatalogItemSetCertificateType', value)
    },
    getWorkspaceCertificates () {
      return this.$store.dispatch('ebsCertificatesGet', { requestData: { workspaceId: this.loggedInWorkspaceId } })
    },
    getCourseWorkspaceSettings () {
      this.requestPending = true
      const catalogId = this.$route.params.catalogId
      this.$store.dispatch('ebsCatalogItemGetWorkspaceSettings', catalogId).finally(() => {
        this.getWorkspaceCertificates().finally(() => {
          this.requestPending = false
          this.$eventBus.$emit('stop-loading')
        })
      })
    }
  },
  created () {
    if (this.isRouteCatalogItem && !this.courseWorkspaceSettingsWorkspaces.length) {
      this.getCourseWorkspaceSettings()
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/courses/courseaddeditcertificate";
</style>
